import dayjs from 'dayjs'

const formatDate = value => dayjs(value).format('DD/MM/YYYY')

export default formatDate
